<div class="sales-capacity-even-align">
    <div class='sales-capacity-container'>
        <div class='capacity-header'>
            {{'servicePersonnel.salesCapacitySetup'| translate}}
                <div class="controls">
                    <div class="cancel"
                    (click)="onCancelClicked()" 
                    [ngClass]="isAppointmentPerDayEdited ||isPerTimePeriodEdited ?'enabled':''">{{'overrideCapacity.cancel'| translate}}</div>
                    <div class="save" 
                    (click)="onSaveClicked()" 
                    [ngClass]="isAppointmentPerDayEdited ||isPerTimePeriodEdited ?'enabled':''">{{'overrideCapacity.save'| translate}}</div>
                </div>
        </div>

    <div>
            <app-sales-shop-max 
            [saveClicked]="isAppPerTimeDaySaveClicked"
            [cancleClicked]="isCancelClicked"
            (formEdited)="appointmentsPerDayFormEdited($event)"
            (cancleClick)="resetCancleClickValue($event)"
            (saveClick)="resetSaveClickedValue($event)"
            ></app-sales-shop-max>
        </div>
    </div>

    <div class="shop-max-header">
    {{'departmentCapacity.appointmentsPerTimePeriod'| translate}}
    </div>
    <div  class="d-flex table-value-info">
        <div><span class="material-icons" >info</span></div>
            <div class="d-flex" *ngFor="let info of tableValueInfo; last as isLast">
                <div>{{ info.value | translate}}</div> &nbsp; -  &nbsp;<div>{{info.description | translate }}</div>
                <div class="dot-space" *ngIf="!isLast"> | </div> 
            </div>
    </div>

    <div style="padding:1rem; overflow-y: auto;">
        <app-timeslot-grid *ngIf="masterSlotsLoading$ | async"
            [viewMode]="viewMode"
            [slotDetails$] = "slotDetails$ | async"
            [maxAndMasterSlots$] = "maxAndMasterSlots$ | async"
            (saveChanges)="onSaveChanges($event)"
            [switchInput]=true
            [saveClicked]="isSavedClicked"
            (formEdited)="appointmentPerTimePeriodEdited($event)"
            [cancleClicked]="isAppPerTimePeriodCancleClicked"
            (cancleClick)="resetCancleClickedAppTable($event)">
        </app-timeslot-grid>
    </div>
</div>
